import React, { Component, Fragment } from 'react';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Filter, Main } from 'Containers';
import { DISCREPANCY_REPORT_FORM_NAME } from 'Common/FormEnum';
import { DiscrepancyReportEnum } from 'Common/FieldEnum';
import * as FilterSelectors from 'State/filters/selectors';
import { errorToast } from 'Common/ToastHelper';
import { ReportGeneration } from 'Common/ObjectHelper';
import {
  clearFilterErrorMsg,
  getVendorForCurrentSite,
} from 'State/filters/actions';
import { submitForm } from 'State/forms/actions';

import { INITIAL_VALUES, PrintTypeEnum } from '../helper';
import DiscrepancyReportComponent from '../components/DiscrepancyReport';
import * as CommonPrintSelector from '../../commonState/selectors';
import {
  clearPrintReportError,
  printReportData,
} from '../../commonState/actions';

class DiscrepancyReportContainer extends Component {
  static propTypes = {
    getVendorForCurrentSite: PropTypes.func.isRequired,
    clearFilterErrorMsg: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    clearPrintReportError: PropTypes.func.isRequired,
    printReportData: PropTypes.func.isRequired,
    vendorData: PropTypes.array.isRequired,
    vendorDataLoading: PropTypes.bool.isRequired,
    vendorDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    printLoading: PropTypes.bool.isRequired,
    printError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    printData: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    typeOptionsValue: PropTypes.number,
  };

  static defaultProps = {
    vendorDataError: null,
    printError: null,
    typeOptionsValue: PrintTypeEnum.OrderedVsReceived,
    printData: '',
  };

  state = {
    activeIndex: 0,
  };

  typeOptions = [
    {
      value: PrintTypeEnum.OrderedVsReceived,
      label: 'Ordered vs Received',
    },
    {
      value: PrintTypeEnum.OnHandVsPhysical,
      label: 'On Hand vs Physical',
    },
  ];

  componentDidMount() {
    this.props.getVendorForCurrentSite();
  }

  componentDidUpdate(prevProps) {
    const {
      clearPrintReportError,
      clearFilterErrorMsg,
      printData,
    } = this.props;
    if (
      errorToast(this.props, prevProps, 'vendorDataError') ||
      errorToast(this.props, prevProps, 'printError')
    ) {
      clearFilterErrorMsg();
      clearPrintReportError();
    }

    if (printData && printData !== prevProps.printData) {
      ReportGeneration(printData, 'Discrepancy Report');
      clearFilterErrorMsg();
      clearPrintReportError();
    }
  }

  handleAccordionClick = (e, titleProps) => {
    this.setState({
      activeIndex:
        this.state.activeIndex === titleProps.index ? -1 : titleProps.index,
    });
  };

  onPrintClick = () => {
    this.props.submitForm(DISCREPANCY_REPORT_FORM_NAME);
  };

  handleSubmit = values => {
    const valuesCopy = { ...values };
    if (values[DiscrepancyReportEnum.Type] === PrintTypeEnum.OnHandVsPhysical) {
      valuesCopy[DiscrepancyReportEnum.DateTo] =
        valuesCopy[DiscrepancyReportEnum.OnHandDateTo];
      delete valuesCopy[DiscrepancyReportEnum.DateFrom];
    }
    delete valuesCopy[DiscrepancyReportEnum.OnHandDateTo];
    this.props.printReportData('DiscrepancyReport', valuesCopy);
  };

  getMainProps = () => {
    const { printLoading } = this.props;
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Print',
            onClick: this.onPrintClick,
            loading: printLoading,
            disabled: printLoading,
          },
        ],
        shown: true,
      },
    };
  };

  render() {
    const { vendorData, vendorDataLoading, typeOptionsValue } = this.props;
    return (
      <Fragment>
        <Filter title={'Reports | Discrepancy Report'} />

        <Main {...this.getMainProps()}>
          <DiscrepancyReportComponent
            activeIndexes={this.state.activeIndex}
            handleAccordionClick={this.handleAccordionClick}
            typeOptions={this.typeOptions}
            vendorData={vendorData}
            vendorDataLoading={vendorDataLoading}
            typeOptionsValue={typeOptionsValue}
            onSubmit={this.handleSubmit}
            initialValues={INITIAL_VALUES}
          />
        </Main>
      </Fragment>
    );
  }
}

const selector = formValueSelector(DISCREPANCY_REPORT_FORM_NAME);

const mapStateToProps = state => {
  return {
    typeOptionsValue: selector(state, DiscrepancyReportEnum.Type),

    vendorData: FilterSelectors.selectVendorData(state),
    vendorDataLoading: FilterSelectors.getVendorDataLoading(state),
    vendorDataError: FilterSelectors.getVendorDataError(state),

    printLoading: CommonPrintSelector.getPrintLoading(state),
    printError: CommonPrintSelector.getPrintError(state),
    printData: CommonPrintSelector.getPrintData(state),
  };
};

const mapDispatchToProps = {
  getVendorForCurrentSite,
  clearFilterErrorMsg,
  submitForm,
  clearPrintReportError,
  printReportData,
};

export const DiscrepancyReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(DiscrepancyReportContainer);



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/discrepancyreport/containers/DiscrepancyReport.js